import RefreshIcon from '@mui/icons-material/Refresh'
import { LoadingButton } from '@mui/lab'
import { Grid, InputAdornment, TextField } from '@mui/material'
import { Controller, useFormContext } from 'react-hook-form'

import { ControlledTextField } from 'components/common'
import { sanitizedNumberField } from 'helpers/sanitizeNumberInput.helpers'
import { useRecalculateDistance } from 'hooks/useRecalculateDistance'
import { usePermission } from 'providers'
import { TBookingForm } from 'types/form-types'

interface IDistanceInputProps {
  isQuickQuote: boolean
  disabled?: boolean
}

const DistanceInput = (props: IDistanceInputProps) => {
  const { isQuickQuote, disabled } = props

  const {
    control,
    formState: { errors },
  } = useFormContext<TBookingForm>()

  const [isAllowedToMakeBookingDistanceFieldReadonly] = usePermission(
    'MakeBookingDistanceFieldReadonly',
  )

  const { recalculateDistance, distanceCalculationLoading } = useRecalculateDistance()

  return (
    <Grid container columnSpacing={0.5} justifyContent='end' alignItems='center'>
      {isAllowedToMakeBookingDistanceFieldReadonly || isQuickQuote ? (
        <Grid item xs={7}>
          <ControlledTextField
            control={control}
            name='distance'
            label='Distance'
            disabled={disabled}
            readOnly
            size='small'
            endAdornment='mi'
          />
        </Grid>
      ) : (
        <Grid item xs={7}>
          <Controller
            control={control}
            name='distance'
            defaultValue={0}
            render={({ field: { onBlur, onChange, ...restField } }) => (
              <TextField
                {...restField}
                label='Distance'
                disabled={disabled}
                required
                type='text'
                size='small'
                fullWidth
                InputProps={{
                  endAdornment: <InputAdornment position='start'>mi</InputAdornment>,
                }}
                error={!!errors.distance}
                helperText={errors.distance?.message}
                onBlur={() => {
                  onBlur()
                }}
                inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
                onChange={(e) => sanitizedNumberField(e.target.value, onChange)}
              />
            )}
          />
        </Grid>
      )}

      <Grid item>
        <LoadingButton
          loading={distanceCalculationLoading}
          disabled={disabled}
          onClick={recalculateDistance}>
          <RefreshIcon />
        </LoadingButton>
      </Grid>
    </Grid>
  )
}

export default DistanceInput
